/* eslint-disable object-shorthand */
import { privateAPI } from './index';

export const dashboardAPI = privateAPI.injectEndpoints({
  reducerPath: 'publicAPI',

  endpoints: build => ({
    getNewlyHiredEmployees: build.query({
      query: params => ({
        url: 'top/three/users',
        params })
    }),
    getLatestMeetings: build.query({
      query: params => ({
        url: 'top/three/meetings',
        params })
    }),
    getRecentLeaves: build.query({
      query: params => ({
        url: 'top/four/leaves',
        params })
    }),
    getTotalReceivableData: build.query({
      query: company => ({
        url: 'report/ar/aging/detail?duration=today&date_type=date',
        params: company })
    }),
    getTotalPayableData: build.query({
      query: company => ({
        url: 'report/ap/aging/details?duration=today&date_type=date',
        params: company })
    }),
    getIncomeExpenseData: build.query({
      query: ({ duration, company }) => ({
        url: `income/expense/dashboard?duration=${duration}`,
        params: { company: company } })
    }),
    getTopExpenses: build.query({
      query: ({ duration, company }) => ({
        url: `top/expenses/dashboard?duration=${duration}`,
        params: { company: company } })
    }),
  }),
});

export const {
  useGetNewlyHiredEmployeesQuery,
  useGetLatestMeetingsQuery,
  useGetRecentLeavesQuery,
  useGetTotalReceivableDataQuery,
  useGetTotalPayableDataQuery,
  useGetIncomeExpenseDataQuery,
  useGetTopExpensesQuery,
} = dashboardAPI;
